import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const Content = styled.div`
  flex-grow: 1;
  max-height: 100vh;
  display: flex;
`;
